import history from 'app/history'
import store from 'app/store'
import { toastr } from 'react-redux-toastr'
import { I18n } from 'react-redux-i18n'

const BASE_PATH = '/api/v1';
export const toUrl = part => `${BASE_PATH}${part}`;

export const toastErrorHandle = resp => {
  if(resp.status === 404 || 500 <= resp.status) {
    toastr.error(I18n.t('errors.api.internal_error'));
  } else if(resp.json && resp.json.hasOwnProperty('errors')) {
    resp.json.errors.forEach(error => toastr.error(I18n.t('errors.api.data_error'), I18n.t(`errors.api.${error.key}`)));
  }
  return Promise.reject(resp);
}

const headers = (custom = {}) => {
  let base = {};
  let { auth } = store.getState();
  if(auth.jwt) base.Authorization = `Bearer ${auth.jwt}`;
  return new Headers(Object.assign(base, custom));
}

const responseHandler = resp => {
  store.dispatch({ type: 'layout/AJAX_DONE' });

  let { headers, status } = resp;

  if(status === 401 || status === 403) {
    history.push('/login');
    return Promise.reject({ headers, status });
  } else if(status === 404 || 500 <= status) {
    return Promise.reject({ headers, status });
  } else if((resp.headers.get('Content-Type') + '').indexOf('json') !== -1 && resp.status !== 204) {
    return resp.json().then(json => ({ headers, status, json }));
  } else if((resp.headers.get('Content-Type') + '').indexOf('text/plain') !== -1 && resp.status !== 204) {
    return resp.text().then(text => ({ headers, status, text }));
  } else if((resp.headers.get('Content-Type') + '').indexOf('application/xml') !== -1 && resp.status !== 204) {
    return resp.text().then(xml => ({ headers, status, xml }));
  } else if((resp.headers.get('Content-Type') + '').indexOf('zip') !== -1 && resp.status !== 204) {
    return resp.blob()
  } else {
    return { headers, status, json: null };
  }
}

const doRequest = (url, method, options) => {
  var config = { method, headers: headers(options.headers) };
  if(options.body) {
    if(options.rawBody) {
      config.body = options.body;
    } else {
      config.headers.append('Content-Type', 'application/json');
      config.body = JSON.stringify(options.body);
    }
  }
  store.dispatch({ type: 'layout/AJAX_START' });
  return fetch(toUrl(url), config).then(responseHandler);
}

export const get = (url, options = {}) => doRequest(url, 'GET', options);

export const post = (url, body, options = {}) => doRequest(url, 'POST', { ...options, body });

export const put = (url, body, options = {}) => doRequest(url, 'PUT', { ...options, body });

export const del = (url, options = {}) => doRequest(url, 'DELETE', options);

export const patch = (url, options = {}) => doRequest(url, 'PATCH', options);

export const uploadFile = (url, file, onProgress) => new Promise((resolve, reject) => {
  let xhr = new XMLHttpRequest();
  xhr.open('POST', toUrl(url));
  xhr.onload = e => (200 <= e.target.status && e.target.status < 300) ? resolve(e.target) : reject();
  xhr.onerror = reject;
  let { auth } = store.getState();
  if(auth.jwt) {
    xhr.setRequestHeader('Authorization', `Bearer ${auth.jwt}`);
  }
  xhr.setRequestHeader('X-File-Original-Name', file.name);
  if(xhr.upload && onProgress) {
    xhr.upload.onprogress = e => onProgress(Math.round(e.loaded / e.total * 100));
  }
  xhr.send(file);
});
